module.exports = __webpack_public_path__ + "img/flag-kazakhstan.fc793c6d.png";